import { NavigationItem } from '@scale/scaleui';
import React from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { Routes as ScreeningCenterRoutes } from 'react-scale/components/ScreeningCenter/constants';

export const GrowthCenterNavigation: React.FC<{ sidebarOpen: boolean }> = ({ sidebarOpen }) => {
  const { pathname } = useLocation();

  return (
    <nav className="px-2 pb-4 mt-4 space-y-1">
      <div className="cursor-pointer">
        <Link to={Routes.ResumeScreening}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Resume Screening Pipelines"
            icon="file-user"
            current={
              !!matchPath(pathname, {
                path: Routes.ResumeScreening,
                exact: true,
              })
            }
          />
        </Link>
      </div>

      <div className="cursor-pointer">
        <Link to={Routes.OnboardingControlPanel}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Onboarding Funnels"
            icon="filter"
            current={
              !!matchPath(pathname, {
                path: Routes.OnboardingControlPanel,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={ScreeningCenterRoutes.ScreeningCenter}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Screening Center"
            icon="pencil"
            current={
              !!matchPath(pathname, {
                path: ScreeningCenterRoutes.ScreeningCenter,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={Routes.Communication}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Email Communications"
            icon="paper-plane"
            current={
              !!matchPath(pathname, {
                path: Routes.Communication,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={Routes.Sms}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="SMS Communications"
            icon="phone"
            current={
              !!matchPath(pathname, {
                path: Routes.Sms,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={Routes.JobPost}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Job Posts"
            icon="briefcase"
            current={
              !!matchPath(pathname, {
                path: Routes.JobPost,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={Routes.CommunicationsHistory}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Communications History"
            icon="list-timeline"
            current={
              !!matchPath(pathname, {
                path: Routes.CommunicationsHistory,
                exact: true,
              })
            }
          />
        </Link>
      </div>
      <div className="cursor-pointer">
        <Link to={Routes.TemplatesLibrary}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Template Library"
            icon="book"
            current={
              !!matchPath(pathname, {
                path: Routes.TemplatesLibrary,
                exact: true,
              })
            }
          />
        </Link>
      </div>
    </nav>
  );
};
